import { useListSpaces } from '@cocoonspace/sdk-js/domains/spaces/spaces'
import type { Zone } from '@cocoonspace/sdk-js/types/zone'
import { searchConfig } from '@cocoonspace/shared/config/search-config'
import { capitalize } from '@cocoonspace/shared/utils/capitalize'
import { ArrowRight } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { useMemo } from 'react'
import { SpaceCarousel } from '~/components/organisms/space-carousel'
import { buttonVariants } from '~/components/ui/button'
import { select } from '~/domains/search/config/select-api-keys'

const EXCLUDED_ZIPS = [
	'69002',
	'69003',
	'69004',
	'69005',
	'69006',
	'69007',
	'69008',
	'69009',
	'92911',
]

export const DistrictsSpaceCarousel = ({
	zone,
}: {
	zone: Zone
}) => {
	const { t } = useTranslation()

	const { data } = useListSpaces({ zone, select })

	const districts = useMemo(() => {
		return searchConfig.districts[zone]
			.filter((district) => !EXCLUDED_ZIPS.includes(district.zip))
			.map((district) => ({
				...district,
				spaces:
					data?.data.filter(
						(space) => space.address.postal_code === district.zip,
					) ?? [],
			}))
			.filter((district) => district.spaces.length)
	}, [zone, data?.data])

	return (
		<div className='flex w-full flex-col gap-y-8'>
			{districts.map(({ zip, uriParam, latitude, longitude, ...district }) => (
				<div key={zip}>
					<h2 className='mb-4 font-semibold text-2xl'>
						{capitalize(t(`cwDistricts:details.${zip}.title`))}
					</h2>

					<SpaceCarousel
						spaces={district.spaces}
						slidesToScrollMd={4}
					/>

					<div className='text-left md:text-right'>
						<Link
							data-testid='see-all-suggestions-link'
							href={`/salle-de-reunion/${zone}/${uriParam}`}
							target='_blank'
							className={buttonVariants({ variant: 'textPrimary' })}
						>
							{t('cwLandings:seeAllCocoonFrom', {
								district: capitalize(t(`cwDistricts:details.${zip}.title`)),
							})}

							<ArrowRight
								size={16}
								className='ml-1'
							/>
						</Link>
					</div>
				</div>
			))}
		</div>
	)
}
